module.exports = __webpack_public_path__ + "img/sb.a689f85f.png";